
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';
import IconWithTooltip from '@/core/components/IconWithTooltip.vue';

const TEST_ID = 'Kloans-PaymentChip';

@Component({
	components: {
		IconWithTooltip,
	},
})
export default class PaymentChip extends Vue {
	@Prop({ default: 'end' })
	public align!: 'start' | 'center' | 'end';

	@Prop({ default: TEST_ID })
	public dataTestid!: string;

	@Prop()
	public dueText!: string;

	@Prop()
	public fees!: string;

	@Prop()
	public id!: string;

	@Prop({ default: false })
	public isPastDue!: boolean;

	@Prop()
	public payment!: string | number;

	@Prop()
	public feesTooltip!: string;

	get alignmentStyles(): {[key: string]: string} {
		if (this.align === 'start') {
			return {
				'align-items': 'flex-start',
				'text-align': 'left',
			};
		}

		if (this.align === 'center') {
			return {
				'align-items': 'center',
				'text-align': 'center',
			};
		}

		return {
			'align-items': 'flex-end',
			'text-align': 'right',
		};
	}
}
